import React from 'react'
import { useSelector } from 'react-redux'

const useIsAddedBasketByRowId = (rowId) => {
    const storeBasket = useSelector(e => e.basket)
    return storeBasket?.basketList?.find(e => e?.RowId == rowId)
}

export default useIsAddedBasketByRowId